import { useMutation } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { AnimalSensitivityEnum } from '@gql/graphql';
import type { BreedInterestFormValues } from '@presentation/components';
import { useCallback } from 'react';

export const BREED_INTEREST_CREATE_DOG_BREED_INTEREST_SUBSCRIPTION = graphql(`
  mutation BreedInterestCreateDogBreedInterestSubscription(
    $data: CreateDogBreedInterestSubscriptionInput!
  ) {
    createDogBreedInterestSubscription(data: $data) {
      id
    }
  }
`);

export const useCreateDogBreedInterestSubscription = () => {
  const { language, countryCode } = useRouter();

  const [createDogBreedInterestSubscription, { loading }] = useMutation(
    BREED_INTEREST_CREATE_DOG_BREED_INTEREST_SUBSCRIPTION,
  );

  const createDogBreedInterestSubscriptionFromForm = useCallback(
    async (values: BreedInterestFormValues) => {
      const { email, dogBreedNames, marketingEmailConsent, hasADog, lookingFor, sensitivity } =
        values;

      await createDogBreedInterestSubscription({
        variables: {
          data: {
            email,
            language,
            country: countryCode,
            marketingEmailConsent,
            dogBreedNames,
            hasADog,
            lookingFor,
            sensitivities: sensitivity ? ([sensitivity] as AnimalSensitivityEnum[]) : [],
          },
        },
      });
    },
    [countryCode, createDogBreedInterestSubscription, language],
  );

  return {
    createDogBreedInterestSubscriptionFromForm,
    createDogBreedInterestSubscriptionLoading: loading,
  };
};
